<template>
  <div class="jxlc-footer w-1180">
    <div class="footer-content">
      <el-image class="footer-logo" :src="footerLogo" fit="fill"></el-image>
      <div class="footer-list">
          <div class="list-item border-none decorate">
              <div class="title">
                  <el-image :src="functionLogo3" fit="fill"></el-image>
                  <div>理财产品</div>
              </div>
              <div class="bom">
                  <div class="content ellipsis1" v-for="(item, i) in text_2.val.itemList.slice(0, 4)" :key="i" v-show="item.title != '私募理财'">
                      <a target="_blank"  :title="item.title" :href="item.link">{{item.title}}</a>
                  </div>
              </div>
              <div id="edit-mask" style="display: none;">
                  <span :editinfo="text_2.code" class="mask-edit-btn">编辑</span>
              </div>
          </div>
          <div class="list-item decorate">
              <div class="title">
                  <el-image :src="functionLogo4" fit="fill"></el-image>
                  <div>投资陪伴</div>
              </div>
              <div class="bom">
                  <div class="content ellipsis1" v-for="(item, i) in text_3.val.itemList.slice(0, 4)" :key="i">
                      <a target="_blank" :title="item.title" :href="item.link">{{item.title}}</a>
                  </div>
              </div>
              <div id="edit-mask" style="display: none;">
                  <span :editinfo="text_3.code" class="mask-edit-btn">编辑</span>
              </div>
          </div>
          <div class="list-item decorate">
              <div class="title">
                  <el-image :src="functionLogo2" fit="fill"></el-image>
                  <div>信息披露</div>
              </div>
              <div class="bom">
                  <div class="content ellipsis1" v-for="(item, i) in text_4.val.itemList.slice(0, 4)" :key="i">
                      <a target="_blank" :title="item.title" :href="item.link">{{item.title}}</a>
                  </div>
              </div>
              <div id="edit-mask" style="display: none;">
                  <span :editinfo="text_4.code" class="mask-edit-btn">编辑</span>
              </div>
          </div>
          <div class="list-item decorate">
              <div class="title">
                  <el-image :src="functionLogo5" fit="fill"></el-image>
                  <div>关于我们</div>
              </div>
              <div class="bom">
                  <div class="content ellipsis1" v-for="(item, i) in text_5.val.itemList.slice(0, 4)" :key="i">
                      <a target="_blank" :title="item.title" :href="item.link">{{item.title}}</a>
                  </div>
              </div>
              <div id="edit-mask" style="display: none;">
                  <span :editinfo="text_5.code" class="mask-edit-btn">编辑</span>
              </div>
          </div>
          <div class="list-item decorate">
              <div class="title">
                  <el-image :src="functionLogo1" fit="fill"></el-image>
                  <div>友情链接</div>
              </div>
              <div class="bom">
                  <div class="content ellipsis1" v-for="(item, i) in text_1.val.itemList.slice(0, 4)" :key="i">
                      <a target="_blank" :title="item.title" :href="item.link">{{item.title}}</a>
                  </div>
              </div>
              <div id="edit-mask" style="display: none;">
                  <span :editinfo="text_1.code" class="mask-edit-btn">编辑</span>
              </div>
          </div>
      </div>
      <div class="footer-qrcode">
        <div style="text-align: center;">建信理财官微</div>
        <el-image :src="companyInfo.wechat" fit="fill"></el-image>
      </div>
        <div class="footer-qrcode">
            <div style="text-align: center;">建行APP</div>
            <el-image :src="companyInfo.ccb" fit="fill"></el-image>
        </div>
    </div>
    <div class="footer-desc">
      <div class="pb-8">
        <span>建信理财有限责任公司</span>
        <span class="border">IPv6</span>
        <span>版权所有 未经许可不得转载</span>
      </div>
      <div class="pb-8 flex-center">
        <span><a target="_blank" href="https://beian.miit.gov.cn">{{companyInfo.icp}}</a> |</span>
        <el-image :src="badge" fit="fill"></el-image>
        <span>
            <a target="_blank" :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' + companyInfo.beian">粤公网安备 {{companyInfo.beian}}号</a> |
            <a target="_blank" :href="companyInfo.jrxkz">金融许可证</a></span>
      </div>
      <div>
        通讯地址：{{companyInfo.addr}} |
        <a target="_blank" :href="companyInfo.tousu" style="font-weight: 600;">投诉渠道及投诉处理流程</a>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo.png';
import footerLogo from '@/assets/footerLogo.png';
import QRcode from '@/assets/QRcode.png';
import functionLogo1 from '@/assets/functionLogo1.png';
import functionLogo2 from '@/assets/functionLogo2.png';
import functionLogo3 from '@/assets/functionLogo3.png';
import functionLogo4 from '@/assets/functionLogo4.png';
import functionLogo5 from '@/assets/functionLogo5.png';
import badge from '@/assets/badge.png';
export default {
  data() {
    return {
        companyInfo: {},
      logo,
      footerLogo,
      QRcode,
      badge,
        functionLogo1,
        functionLogo2,
        functionLogo3,
        functionLogo4,
        functionLogo5,
        text_1: { code: 'index_footer_text_1|multi_text|522x165|index', val: { itemList: [] } },
        text_2: { code: 'index_footer_text_2|multi_text|522x165|index', val: { itemList: [] } },
        text_3: { code: 'index_footer_text_3|multi_text|522x165|index', val: { itemList: [] } },
        text_4: { code: 'index_footer_text_4|multi_text|522x165|index', val: { itemList: [] } },
        text_5: { code: 'index_footer_text_5|multi_text|522x165|index', val: { itemList: [] } },
      functionList: [
        {
          title: '首页',
          logo: functionLogo1,
          children: [],
        },
        {
          title: '公募理财',
          logo: functionLogo2,
          children: ['公募理财'],
        },
        // {
        //   title: '私募理财',
        //   logo: functionLogo3,
        //   children: ['在售理财', '私享理财'],
        // },
        {
          title: '投资陪伴',
          logo: functionLogo4,
          children: ['理财资讯', '公司资讯', '信息披露'],
        },
        {
          title: '关于我们',
          logo: functionLogo5,
          children: ['公司介绍', '公司荣誉', '信息公示', '诚聘英才'],
        },
      ],
    };
  },
    watch: {
        '$store.getters.commonInfo': {
            handler (newVal) {
                this.companyInfo = newVal.companyInfo
            }
        },
        '$store.getters.decorateInfo': {
            handler (newVal) {
                this.text_1.val.itemList = newVal['index_footer_text_1'].itemList
                this.text_2.val.itemList = newVal['index_footer_text_2'].itemList
                this.text_3.val.itemList = newVal['index_footer_text_3'].itemList
                this.text_4.val.itemList = newVal['index_footer_text_4'].itemList
                this.text_5.val.itemList = newVal['index_footer_text_5'].itemList
            },
            immediate: true
        }
    },
  mounted() {
      this.companyInfo = this.$store.getters.commonInfo.companyInfo
      this.text_1.val.itemList = this.$store.getters.decorateInfo.index_footer_text_1.itemList
      this.text_2.val.itemList = this.$store.getters.decorateInfo.index_footer_text_2.itemList
      this.text_3.val.itemList = this.$store.getters.decorateInfo.index_footer_text_3.itemList
      this.text_4.val.itemList = this.$store.getters.decorateInfo.index_footer_text_4.itemList
      this.text_5.val.itemList = this.$store.getters.decorateInfo.index_footer_text_5.itemList
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.jxlc-footer {
  padding-top: 40px;
  padding-bottom: 16px;
  width: 1180px;
  margin: auto;
  .border-none {
    border-left: 0 !important;
  }
  .footer-content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    .footer-logo {
      width: 200px;
      height: 50px;
    }
    .footer-list {
      display: flex;
      width: 60%;

      .list-item {
        flex: 1;
        min-width: 0;
        padding: 0 16px;
        border-left: 1px solid #cccccc;
        font-size: 16px;
        line-height: 22.4px;
        .title {
          display: flex;
          align-items: center;
          font-weight: 600;
          color: #005bac;
          padding-bottom: 14px;
          .el-image {
            width: 24px;
            height: 24px;
            padding-right: 8px;
          }
        }
        .bom{
          min-height: 50px;
          .content {
            text-align: right;
            color: #333;
            padding-top: 8px;
            padding-right: 12.8px;
          }
        }
      }
    }
    .footer-qrcode {
      font-size: 16px;
      font-weight: 600;
      line-height: 22.4px;
      color: #333;
      .el-image {
        width: 120px;
        height: 120px;
        margin-top: 24px;
      }
    }
  }
  .footer-desc {
    font-size: 14px;
    line-height: 19.6px;
    color: #333;
    text-align: center;

    .border {
      border: 1px solid #333333;
      border-radius: 30px;
      padding: 0 4px;
      margin: 0 4px;
    }
    .pb-8 {
      padding-bottom: 8px;
    }
    .flex-center{
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .el-image{
      width: 20px;
      height: 20px;
      margin: 0 4px;
    }
  }
}
</style>
